import React, {useEffect, useState} from "react";
import Icon from "../Icon/Icon";
import {InfiosViewSwitch} from "./ViewSwitch.style";
import {InfiosPaginationWrapper} from "../SearchResults/SearchResults.style";
import ContentTeaserList from "../ContentTeaser/ContentTeaserList/ContentTeaserList";
import ContentTeaserGrid from "../ContentTeaser/ContentTeaserGrid/ContentTeaserGrid";
import {ErrorBoundary} from "react-error-boundary";
import {urlHasParam} from "../../utils/js/params";
import {sha1} from "object-hash"
import InfiniteScroll from "react-infinite-scroller";
import {SkeletonWrapper} from "../Filter/Filter.style";
import Skeleton from "../Skeleton/Skeleton";


function ViewSwitch(props) {
    const {contentList, pagination, fullWidth, isLoading, orderBy, changeOrder, showHighlightedDescription, linkText, showPagination, handlePagination, totalResults, changed, pageOffset} = props
    const [isToggledOn, setIsToggledOn] = useState(true);
    const asc = 'asc';
    const desc = 'desc';
    const [orderButtons, setOrderButtons] = useState([
        {icon: 'alph', name: 'title', sort:  desc, active: false}, {icon: 'time', name: 'date', sort: desc, active: true}]);
    const [cumulativeContentList, setCumulativeContentList] = useState([]);

    function handleClick() {
        sessionStorage.setItem('isToggledOn', JSON.stringify(!isToggledOn));
        setIsToggledOn(!isToggledOn);
    }


    function toggleSort(def) {
        return def === asc ? desc : asc;
    }

    function handleOrderingClick(orderSwitch) {
        let toggledSort = toggleSort(orderSwitch.sort);
        changeOrder(orderSwitch.name, toggledSort);
        setOrderButtons(orderButtons.map(b => (b.name === orderSwitch.name) ? {...b, sort: toggledSort, active: true} : {...b, active: false}))

        sessionStorage.setItem('orderSwitch', JSON.stringify(orderSwitch));
    }

    useEffect(() => {
        const sessionOrderSwitch = JSON.parse(sessionStorage.getItem('orderSwitch'));
        const sessionToggled = JSON.parse(sessionStorage.getItem('isToggledOn'));

        if(sessionToggled != null) {
            setIsToggledOn(sessionToggled)
        } else {
            sessionStorage.setItem('isToggledOn', JSON.stringify(isToggledOn));
        }

        if(!!sessionOrderSwitch) {
            handleOrderingClick(sessionOrderSwitch);
        }
    }, []);

    useEffect(() => {
        if (!showPagination && contentList) {
            if(pageOffset === 0){
                setCumulativeContentList(previousList => contentList);
            }else{
                setCumulativeContentList(previousList => [...previousList, ...contentList]);
            }

        }
    }, [contentList, showPagination]);

    const buildContentSwitch = content => (
        <div className={`viewswitch__content_${isToggledOn ? "grid" : "list"}`}>
            {isToggledOn
                ? content &&
                content.map((result, index) => {
                    return (
                        <ContentTeaserGrid
                            linkText={linkText}
                            key={`content-item-${index}`} {...result}
                            showHighlightedDescription={showHighlightedDescription}
                            highlight={result?.highlight}
                            sectionParent="viewswitch__content_grid__anchor"
                        />
                    );
                })
                : content &&
                content.map((result, index) => {
                    return (
                        <ContentTeaserList linkText={linkText} fullWidth={fullWidth}
                                           key={`content-item-${index}`} {...result} />
                    );
                })}
        </div>
    );

    return (
        <InfiosViewSwitch fullWidth={fullWidth}>
            <div className="viewswitch">
                <div className="viewswitch__buttons">
                    <div className="viewswitch__buttons__switches">
                        <button onClick={handleClick} className="viewswitch__button">
                            {isToggledOn ? (
                                <Icon icon="view-grid" className="viewswitch__icon_grid"/>
                            ) : (
                                <Icon icon="view-list" className="viewswitch__icon_list"/>
                            )}
                        </button>
                        {orderButtons.map(button => (
                            <button key={sha1(button)} onClick={() => handleOrderingClick(button)}
                                    className="viewswitch__button">
                                <Icon icon={`${button.icon}-${button.sort}`}
                                      className={`viewswitch__ico--sort viewswitch__ico--${button.name}-${button.sort} ${button.active ? 'viewswitch__ico--active' : ''}`}/>
                            </button>
                        ))}
                    </div>
                    {showPagination && pagination &&
                        <InfiosPaginationWrapper className='top-pagination' isLoading={isLoading}>
                            {pagination}
                        </InfiosPaginationWrapper>
                    }
                </div>

                {
                    !showPagination && cumulativeContentList.length < totalResults ? (
                        <InfiniteScroll
                            pageStart={0}
                            loadMore={() => handlePagination(cumulativeContentList.length / 9)}
                            hasMore={cumulativeContentList.length < totalResults}
                            loader={(
                                <SkeletonWrapper key={0} className="skeleton-wrapper">
                                    <Skeleton height={382} width={103} marginBottom={20} />
                                    <Skeleton height={382} width={103} marginBottom={20} />
                                    <Skeleton height={382} width={103} marginBottom={20} />
                                </SkeletonWrapper>
                            )}
                        >
                            {buildContentSwitch(cumulativeContentList)}
                        </InfiniteScroll>
                    )
                        :
                        buildContentSwitch(cumulativeContentList)
                }

                {showPagination && !isLoading && buildContentSwitch(contentList)}
                {isLoading && (
                    <SkeletonWrapper key={0} className="skeleton-wrapper">
                        <Skeleton height={382} width={103} marginBottom={20} />
                        <Skeleton height={382} width={103} marginBottom={20} />
                        <Skeleton height={382} width={103} marginBottom={20} />
                        <Skeleton height={382} width={103} marginBottom={20} />
                        <Skeleton height={382} width={103} marginBottom={20} />
                        <Skeleton height={382} width={103} marginBottom={20} />
                    </SkeletonWrapper>
                )}


                {showPagination && pagination &&
                    <InfiosPaginationWrapper className='bottom-pagination' isLoading={isLoading}>
                        {pagination}
                    </InfiosPaginationWrapper>
                }
            </div>
        </InfiosViewSwitch>
    );
}

const ViewSwitchHandleErrors = props => {
    return (
        <ErrorBoundary fallback={props.isInEditor || urlHasParam('wcmmode=disabled') ? <div style={{minHeight: '50px', display: 'flex', alignItems: 'center', backgroundColor: '#ffe1db'}}><p>The view switch component is currently experiencing errors. Please try again later.</p></div> : <div></div>}>
            <ViewSwitch {...props}/>
        </ErrorBoundary>
    )
}

export default ViewSwitchHandleErrors;
